import { Router } from '@angular/router';

export const DATA_DELETION_PATH = '/data-deletion';

export function isDataDeletionUrl(url: string): boolean {
  const path = (url || '').split(/[?#]/)[0].replace(/\/$/, '');
  return path === DATA_DELETION_PATH;
}

export function isDataDeletionNavigation(router: Router): boolean {
  const navigation = router.getCurrentNavigation();
  return isDataDeletionUrl(navigation?.extractedUrl.toString() || router.url);
}
